import { dailyMessages, choiceHoverMessages } from "./calendarData";

/** 날짜별 메시지를 랜덤하게 셔플하는 함수 */
export const shuffleDailyMessages = () => {
  const shuffled = [...dailyMessages];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/** 택일 달력 호버 메시지를 랜덤하게 셔플하는 함수 */
export const shuffleChoiceHoverMessages = () => {
  const shuffled = [...choiceHoverMessages];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/** 이모지 타입 랜덤 함수 */
export const getRandomEmoji = () => {
  const emojis = ['a', 'b', 'c', 'd', 'e'];
  return emojis[Math.floor(Math.random() * emojis.length)];
};

/** 역학달력 파라미터 생성 */
export const createParams = (yearMonth) => {
  const [yearText, monthText] = yearMonth.split(' ');
  const year = yearText.replace(/[^\d]/g, '');
  const month = monthText.replace(/[^\d]/g, '');
  return {
    searchDay: `${year}-${month}`,
    systemId: import.meta.env.VITE_APP_SYSTEMID,
  };
};

/** 일진달력 파라미터 생성 */
export const createFortuneParams = (yearMonth) => {
  if (!yearMonth || typeof yearMonth !== 'string') return yearMonth;
  const [yearText, monthText] = yearMonth.split(' ')
  const year = yearText.replace(/[^\d]/g, '');
  const month = monthText.replace(/[^\d]/g, '');
  return {
    year,
    month,
  }
};

/** 절기 데이터 추출 */
export const extractSeasonData = (calendarData, todayDateStr) => {
  const {days, today} = calendarData;

  const seasonData = days.find((day) => day.season.trim() !== '');
  const {day, season} = seasonData;
  const [year, month, date] = day.split('-');
  const [seasonTxt, time] = season.split(' ');

  let monthju = '';
  // 현재 달 이라면
  if (todayDateStr === seasonData.day.slice(0, 7) && today?.monthju) {
    monthju = today.monthju;
  } else {
    monthju = seasonData?.monthju;
  }

  const timeTxt = time.substring(0, 2);
  const minTxt = time.substring(2);
  const monthTxt = month;
  const dateTxt = date;

  return {
    seasonText: `${seasonTxt} ${monthTxt}월 ${dateTxt}일 ${timeTxt}시 ${minTxt}분`,
    seasonMonth: monthju,
  }
};

/**
 * viewTitle 포맷 변환 함수
 * - 'YYYY년 MM월' -> 'YYYYMM'
 */
export const convertViewTitleToYYYYMM = (viewTitle) => {
  const match = viewTitle.match(/(\d{4})년\s*(\d{1,2})월/);
  if (!match) return null;

  const year = match[1];
  const month = match[2].padStart(2, '0');

  return `${year}${month}`;
};

/** 일운 달성확률 별 레벨 변환 함수 */
export const getEnergyLevel = (value) => {
  if (value < 45) return 1;
  if (value < 70) return 2;
  if (value < 80) return 3;
  if (value < 87.5) return 4;
  return 5;
};